import React, { ReactElement } from 'react';
import { Body, Headline, Text } from '../..';
import './style.css';

export default function CommunityCallout(): ReactElement {
  return (
    <section className="mt-[120px] flex justify-center p-4">
      <div className="community-callout grid max-w-[1160px] grid-cols-2 gap-12">
        <div className="flex items-center justify-start">
          <div className="w-[433px]">
            <Text className="mb-4 block" level="mono" color="purple">
              It takes a village
            </Text>
            <Headline level="2" color="blue">
              Join the Stark community
            </Headline>
            <Body className="mb-8 mt-4" color="blue">
              Connect with a global community of experts from all industries and
              stay up to date with the largest collection of accessibility
              resources on the internet.
            </Body>

            <a href="/slack" className="link link--button">
              Join our community
            </a>
          </div>
        </div>
        <div className="relative">
          <img
            alt="Group of Stark users clustered in a circle with teal, yellow, and coral colored circles surrounding them."
            src="https://images.getstark.co/marketing/highlights/homepage__community.webp"
            className="w-[481px] max-w-full"
          />
          <img
            src="/homepage__feature-5-arrow.svg"
            alt=""
            role="presentation"
            className="community-callout__arrow absolute bottom-[-84px] left-[-90px] h-[168px] w-[135px]"
          />
        </div>
      </div>
    </section>
  );
}
